// extracted by mini-css-extract-plugin
export default {"formContainer":"ContactConfigureBottomPanel_formContainer__8TGA1"};